import navbar from '@/components/NavBar.vue';
import Stepper from '@/components/wizardNutrition/stepper/index.vue';
import StepperNavigation from '@/components/wizardNutrition/stepper-navigation/index.vue';
import DosageProduct from '@/components/wizardNutrition/dosageProduct/index.vue';
import { mapState } from 'vuex';

export default {
  name: 'nutrition-step-three',
  components: {
    navbar,
    Stepper,
    StepperNavigation,
    DosageProduct,
  },
  props: [],
  data() {
    return {

    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation']),
  },
  mounted() {

  },
  methods: {

  },
};
